const blockers: { [key: string]: (() => Promise<any>)[] } = {};

function run(tag: string, cb: () => Promise<any>) {
  cb().finally(() => {
    const idx = blockers[tag].indexOf(cb);
    if (idx > -1) {
      blockers[tag].splice(idx, 1);
    }

    if (blockers[tag].length > 0) {
      run(tag, blockers[tag][0]);
    }
  });
}

export function block<T>(tag: string, cb: () => Promise<T>) {
  if (blockers[tag] && blockers[tag].length > 0) {
    return blockers[tag].push(cb);
  }
  blockers[tag] = blockers[tag] || [];
  blockers[tag].push(cb);
  run(tag, cb);
}
